if (!customElements.get('product-swatches')) {
  customElements.define('product-swatches', class ProductSwatches extends HTMLElement {
    constructor() {
      super();
      this.productSkuPart = this.getAttribute("data-product-sku-part");
      this.initialize();
    }

    async initialize() {
      this.count();

      if (this.isPDP()) {
        await this.render();
      }
    }

    isPDP() {
      return document.body.classList.contains('product-page');
    }

    async fetchProductData() {
      try {
        let page = 1;
        let allProducts = [];

        while (true) {
          const response = await fetch(`/collections/all?view=swatches&page=${page}`);
          if (!response.ok) throw new Error('Failed to fetch data');

          const productsObject = await response.json();
          const products = productsObject.products;

          if (!products || products.length === 0) break;

          allProducts = allProducts.concat(products);
          page++;
        }

        return allProducts.filter(product =>
          product.variants.some(variant => variant.sku.includes(this.productSkuPart))
        );
      } catch (error) {
        console.error(error);
        return [];
      }
    }

    getLocalePrefix() {
      const path = window.location.pathname;
      const localeMatch = path.match(/^\/(de|it)(\/|$)/);
      return localeMatch ? `/${localeMatch[1]}` : '';
    }

    async render() {
      const products = await this.fetchProductData();
      const optionsWrapper = this.querySelector('.product-swatches__options-wrapper');
      const currentID = this.getAttribute("data-product-id");

      if (!this.productSkuPart || !optionsWrapper) return;

      const localePrefix = this.getLocalePrefix();

      for (const product of products) {
        const link = document.createElement('a');
        link.classList.add("product-swatches__option");
        link.setAttribute("data-color-option", product.color_id);

        const cleanUrl = product.url.replace(/^\/(de|it)\//, '/');
        link.setAttribute('href', localePrefix + cleanUrl);

        link.innerHTML = `<img src=${product.img} width="80"></img>`;

        if (currentID === product.id) {
          link.classList.add("selected");
        }
        optionsWrapper.appendChild(link);
      }
    }

    async count() {
      const products = await this.fetchProductData();
      const productColorsElement = this.querySelector('.product-colors');
      if (!this.productSkuPart || !productColorsElement) return;

      const colorText = products.length === 1 ? "Color" : "Colors";
      productColorsElement.textContent = `${products.length} ${colorText}`;
    }

  });
}